import { render, staticRenderFns } from "./ScoutingMatrixElement.vue?vue&type=template&id=10026d91&scoped=true&"
import script from "./ScoutingMatrixElement.vue?vue&type=script&lang=ts&"
export * from "./ScoutingMatrixElement.vue?vue&type=script&lang=ts&"
import style0 from "./ScoutingMatrixElement.vue?vue&type=style&index=0&id=10026d91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10026d91",
  null
  
)

export default component.exports